import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DmsModule } from 'apps/idl/src/modules/dms/dms.module';
import { CONV_META_CONFIG } from 'apps/idl/src/modules/dms/model/MetaConversationBuilder';
import { MetaInvoiceBuilder } from './model/MetaInvoiceBuilder';
import { MetaTourneeBuilder } from './model/MetaTourneeBuilder';
import { MetaTraitementBuilder } from './model/MetaTraitementBuilder';
import { MetaTransmissionBuilder } from './model/MetaTransmissionBuilder';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		DmsModule.forRoot([
			MetaTraitementBuilder,
			MetaTransmissionBuilder,
			MetaTourneeBuilder,
			MetaInvoiceBuilder
		])
	],
	providers: [
		MetaTraitementBuilder,
		MetaTransmissionBuilder,
		MetaTourneeBuilder,
		MetaInvoiceBuilder,
		{
			provide: CONV_META_CONFIG,
			useValue: [
				MetaTransmissionBuilder,
				MetaTraitementBuilder,
				MetaTourneeBuilder,
				MetaInvoiceBuilder
			]
		}
	]
})
export class IdlDmsModule { }
